import { NgModule }     from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PowerBiReportContainerComponent } from './powerbi-report-container/powerbi-report-container.component';
import { WorldViewContainerComponent } from './world-view-container/world-view-container.component';


const routes: Routes = [

    { path: '', 
      children: [
        { path: 'dashboard', component: PowerBiReportContainerComponent },
        { path: 'worldview', component: WorldViewContainerComponent },
      
    ]},
];

@NgModule({
    imports: [
        RouterModule.forChild(routes)
    ],
    exports: [
        RouterModule
    ],
    providers: [
        //DeviceSettingsDeactivateGuardService,        
    ]
})
export class DashboardRoutingModule { }



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/features/dashboard/dashboard-routing.module.ts